import React from "react";
import {
    Button,
    Table as MaterialTable,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@material-ui/core";
import { css } from "./styles";

export function Table({ produtos, handleRemoverProduto }) {
    const styles = css();

    return (
        <TableContainer className={styles.tableContainer}>
            <MaterialTable>
                <TableHead>
                    <TableRow className={styles.tableHead}>
                        <TableCell className={styles.tableHeadCellAlfa}>Alfa numérico</TableCell>
                        <TableCell className={styles.tableHeadCell}>ID dos produtos</TableCell>
                        <TableCell className={styles.tableHeadCell}>Ficha</TableCell>
                        <TableCell className={styles.tableHeadCell}>Remover</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {produtos.map((produto, index) => (
                        <TableRow key={index}>
                            <TableCell className={styles.tableRowCell} component="th" scope="row">
                                {produto.alfa}
                            </TableCell>

                            <TableCell className={styles.tableRowCell} component="th" scope="row">
                                {produto.id}
                            </TableCell>

                            <TableCell className={styles.tableRowCell} component="th" scope="row">
                                {produto.ficha}
                            </TableCell>

                            <TableCell className={styles.tableRowCell} component="th" scope="row">
                                <Button
                                    onClick={() => handleRemoverProduto(index, produto.key)}
                                    className={styles.buttonRemover}
                                >
                                    Remover
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </MaterialTable>
        </TableContainer>
    );
}
